import React, { useEffect, useState } from 'react'
import { Breadcrumbs, Button, IconButton, InputBase, Paper, Stack, Typography, Menu, MenuItem } from '@mui/material';
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import styless from './scheduleQuote/partList.module.css';
import { UploadImg } from '../../Svg';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from '../../utils/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Upload } from '@mui/icons-material';
import { Search, Add, FilterList, UploadOutlined, Opacity } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import ProductTable from '../../component/scheduleComps/ScheduleSearchTable';
import { getAllUsersThunk } from '../../redux/customer/customerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { createScheduleEnquiryThunk } from '../../redux/schedulecartslice';
import { useNavigate } from 'react-router-dom';
import DeliveryAddressPopup from '../../component/scheduleComps/DeliveryAddressPopup';

const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    fontFamily: `'Public Sans', sans-serif`,
}));

const NewSchedule = () => {
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([])
    const [searchLoading, setSearchLoading] = useState(false)
    const [search, setsearch] = useState('')
    const [selectedproducts, setselectedProducts] = useState([])
    const [quantityErrors, setQuantityErrors] = useState({});
    const [totalQuantityErrors, setTotalQuantityErrors] = useState({});
    const [editingProductId, setEditingProductId] = useState(null);
    const { allUsers } = useSelector((state) => state.customer);
    const [editingTotalProductId, setEditingTotalProductId] = useState(null);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [open, setOpen] = useState(false);
    const [shippingAddress,selectShippingAddress] = useState(null)

    const formik = useFormik({
        initialValues: {
         
            purchaseOrderUri: '',
            period: '',
            scheduleDate: '',
            remarks: '',
            userId: ''
        },
        validationSchema: Yup.object({
            purchaseOrderUri: Yup.string()
                .url('Please upload a valid file')
                .required('Purchase Order is required'),
            period: Yup.number()
                .positive('Period must be a positive number')
                .required('Period is required'),
            scheduleDate: Yup.date()
                .typeError('Invalid date format')
                .required('Schedule Date is required'),

            userId: Yup.string().required('customer is required'),
        }),
        onSubmit: async (values) => {
            const address = allUsers?.find(i => i?._id === values.userId)
            selectShippingAddress(address)
            setOpen(true)
        },
    });

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        try {
            if (file) {
                setLoading(true);
                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                    });
                    formik.setFieldValue('purchaseOrderUri', data?.data?.url);
                }
            }
        } catch (err) {
            console.error(err);
            toast.error('Error uploading file');
        } finally {
            setLoading(false);
        }
    };

    const searchProduct = async (e) => {
        e.preventDefault()
        try {
            setSearchLoading(true)
            const { data } = await api.getExactSearch(`?search=${search}`)

            if (data) {
                setProducts(data?.data)
            }
        } catch (err) {
            console.log(err);
        } finally {
            setSearchLoading(false)
        }
    }

    const handleRemoveProduct = (productId) => {
        setselectedProducts(prev =>
            prev.filter(item => item.productId !== productId)
        );
        // Clear errors for removed product
        setQuantityErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[productId];
            return newErrors;
        });
        setTotalQuantityErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[productId];
            return newErrors;
        });
    }

    // Validate quantity against minimumMultiplier and total quantity
    const validateQuantity = (productId, value, totalQty) => {
        const product = selectedproducts.find(p => p.productId === productId);
        const minMultiplier = product?.productDetails?.inventory?.minimumMultiplier || 1;
        const numValue = Number(value);
        const numTotalQty = Number(totalQty);

        if (value === '') {
            setQuantityErrors(prev => ({ ...prev, [productId]: '' }));
            return false;
        }

        if (isNaN(numValue)) {
            setQuantityErrors(prev => ({ ...prev, [productId]: 'Please enter a valid number' }));
            return false;
        }

        if (numValue <= 0) {
            setQuantityErrors(prev => ({ ...prev, [productId]: 'Quantity must be greater than 0' }));
            return false;
        }

        if (numValue % minMultiplier !== 0) {
            setQuantityErrors(prev => ({
                ...prev,
                [productId]: `Quantity must be in multiples of ${minMultiplier}`
            }));
            return false;
        }

        if (numValue > numTotalQty) {
            setQuantityErrors(prev => ({
                ...prev,
                [productId]: `Cannot exceed total quantity (${totalQty})`
            }));
            return false;
        }

        setQuantityErrors(prev => ({ ...prev, [productId]: '' }));
        return true;
    };

    // Validate total quantity against minimumMultiplier
    const validateTotalQuantity = (productId, value) => {
        const product = selectedproducts.find(p => p.productId === productId);
        const minMultiplier = product?.productDetails?.inventory?.minimumMultiplier || 1;
        const numValue = Number(value);

        if (value === '') {
            setTotalQuantityErrors(prev => ({ ...prev, [productId]: '' }));
            return false;
        }

        if (isNaN(numValue)) {
            setTotalQuantityErrors(prev => ({ ...prev, [productId]: 'Please enter a valid number' }));
            return false;
        }

        if (numValue <= 0) {
            setTotalQuantityErrors(prev => ({ ...prev, [productId]: 'Quantity must be greater than 0' }));
            return false;
        }

        if (numValue % minMultiplier !== 0) {
            setTotalQuantityErrors(prev => ({
                ...prev,
                [productId]: `Quantity must be in multiples of ${minMultiplier}`
            }));
            return false;
        }

        setTotalQuantityErrors(prev => ({ ...prev, [productId]: '' }));
        return true;
    };

    const handleQuantityChange = (productId, newQuantity, totalQty) => {
        // Update the state immediately
        setselectedProducts(prev =>
            prev.map(item => {
                if (item.productId === productId) {
                    return {
                        ...item,
                        quantity: newQuantity === '' ? '' : parseInt(newQuantity, 10) || 0
                    };
                }
                return item;
            })
        );

        // Then validate
        validateQuantity(productId, newQuantity, totalQty);
    };

    const handleTotalQuantityChange = (productId, newQuantity, quantity) => {
        // Update the state immediately
        setselectedProducts(prev =>
            prev.map(item => {
                if (item.productId === productId) {
                    return {
                        ...item,
                        totalQty: newQuantity === '' ? '' : parseInt(newQuantity, 10) || 0,
                        // Ensure quantity doesn't exceed the new total quantity
                        quantity: Math.min(item.quantity, newQuantity === '' ? Infinity : parseInt(newQuantity, 10) || 0)
                    };
                }
                return item;
            })
        );

        // Then validate
        validateTotalQuantity(productId, newQuantity);

        // Also validate if existing quantity is still valid with new total
        const product = selectedproducts.find(p => p.productId === productId);
        if (product) {
            validateQuantity(productId, product.quantity, newQuantity);
        }
    };

    const handleQuantityBlur = (productId, isTotal = false) => {
        if (isTotal) {
            setEditingTotalProductId(null);
        } else {
            setEditingProductId(null);
        }

        const product = selectedproducts.find(p => p.productId === productId);
        if (product) {
            if (isTotal) {
                const isValid = validateTotalQuantity(productId, product.totalQty);
                if (!isValid) {
                    // Reset to last valid total quantity
                    setselectedProducts(prev =>
                        prev.map(p => {
                            if (p.productId === productId) {
                                return { ...p, totalQty: p.previousValidTotalQty || 1 };
                            }
                            return p;
                        })
                    );
                }
            } else {
                const isValid = validateQuantity(productId, product.quantity, product.totalQty);
                if (!isValid) {
                    // Reset to last valid quantity
                    setselectedProducts(prev =>
                        prev.map(p => {
                            if (p.productId === productId) {
                                return { ...p, quantity: p.previousValidQuantity || 1 };
                            }
                            return p;
                        })
                    );
                }
            }
        }
    };

    const handleQuantityFocus = (productId, isTotal = false) => {
        // Store the current valid quantity before editing
        setselectedProducts(prev =>
            prev.map(item => {
                if (item.productId === productId) {
                    return {
                        ...item,
                        previousValidQuantity: isTotal ? item.previousValidQuantity : item.quantity,
                        previousValidTotalQty: isTotal ? item.totalQty : item.previousValidTotalQty
                    };
                }
                return item;
            })
        );

        if (isTotal) {
            setEditingTotalProductId(productId);
        } else {
            setEditingProductId(productId);
        }
    };

    const isQuantityValid = (productId) => {
        const product = selectedproducts.find(p => p.productId === productId);
        if (!product) return false;

        const quantity = product.quantity;
        const totalQty = product.totalQty;
        const minMultiplier = product.productDetails?.inventory?.minimumMultiplier || 1;

        return (
            quantity > 0 &&
            totalQty > 0 &&
            quantity % minMultiplier === 0 &&
            totalQty % minMultiplier === 0 &&
            quantity <= totalQty
        );
    };

    const validateBeforeSubmit = () => {
        const hasInvalidQuantity = selectedproducts.some(item => !isQuantityValid(item.productId));
        if (hasInvalidQuantity) {
            toast.error('Please enter valid quantities (multiples of SPQ) for all items');
            return false;
        }

        if (selectedproducts.length === 0) {
            toast.error('Please add at least one product');
            return false;
        }

        return true;
    };

    const handleSubmit = () => {
        if (!validateBeforeSubmit()) {
            return;
        }
        // Proceed with form submission
        formik.handleSubmit();
    };

    const handleSaveSelection = async () => {
        const day = new Date(formik.values.scheduleDate).getDate();
        const formData = {
            ...formik.values,
            products:selectedproducts,
            scheduleDate: day,
            shippingAddress: selectedAddress
        };

        console.log(formData);
        const status = await dispatch(createScheduleEnquiryThunk(formData))
        console.log(status);

        if (status?.payload === 200) {
            navigate('/schedule/scheduleEnquires')
        }

    };

    const handleAddtoSchedule = (productId, quantity, productDetails) => {
        if (!quantity || isNaN(quantity)) {
            toast.error('Please enter a valid quantity');
            return;
        }

        const numQuantity = Number(quantity);
        const minMultiplier = productDetails?.inventory?.minimumMultiplier || 1;

        if (numQuantity % minMultiplier !== 0) {
            toast.error(`Quantity must be in multiples of ${minMultiplier}`);
            return;
        }

        setselectedProducts(prev => {
            const existingIndex = prev.findIndex(item => item.productId === productId);

            if (existingIndex >= 0) {
                // Update existing product
                const updatedProducts = [...prev];
                updatedProducts[existingIndex] = {
                    ...updatedProducts[existingIndex],
                    quantity: numQuantity,
                    totalQty: numQuantity, // Set both to same value initially
                    productDetails
                };
                return updatedProducts;
            } else {
                // Add new product
                return [...prev, {
                    productId,
                    quantity: numQuantity,
                    totalQty: numQuantity,
                    productDetails,
                    previousValidQuantity: numQuantity,
                    previousValidTotalQty: numQuantity
                }];
            }
        });
    };

    console.log(selectedproducts);

    useEffect(() => {
        dispatch(getAllUsersThunk())
    }, [])



    return (
        <>
            <NestedUserHeader
                index="New schedule"
                root="Dashboard"
                buttonText={'Add Subcategory'}
            />


            <div className={styles.formSection}>
                <div className={styles.card}>
                    <form style={{ display: 'flex', gap: 10 }}>
                        <SearchInput>
                            <IconButton aria-label="search">
                                <Search />
                            </IconButton>
                            <InputBase
                                placeholder="Search…"
                                value={search}
                                onChange={(e) => setsearch(e.target.value)}
                            />
                        </SearchInput>
                        <button
                            type="submit"
                            className={styles.searchBtn}
                            onClick={searchProduct}
                            disabled={searchLoading}
                            style={{ background: searchLoading ? '#9573e6' : '#512DA8', color: 'whote', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 10px', borderRadius: 2, gap: 5 }}
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.33488 11.0342C4.23694 11.68 5.29827 12.0252 6.38462 12.0252C7.10587 12.0252 7.81987 11.873 8.48579 11.5774C9.15169 11.2819 9.75628 10.849 10.2652 10.3037C10.7742 9.75837 11.1775 9.11138 11.4526 8.39981C11.7277 7.68824 11.8692 6.92579 11.8692 6.15596C11.8692 4.99661 11.5484 3.86278 10.9466 2.89782C10.3448 1.93281 9.48872 1.17957 8.48579 0.734475C7.48276 0.289331 6.37861 0.17273 5.31329 0.399772C4.24804 0.626799 3.27055 1.18697 2.50402 2.00826C1.73755 2.82947 1.21627 3.87496 1.00515 5.01218C0.794022 6.14939 0.902328 7.3282 1.31661 8.39981C1.73091 9.47145 2.43291 10.3885 3.33488 11.0342ZM4.04961 2.39971C4.74144 1.90443 5.55402 1.64057 6.38462 1.64057C7.49826 1.64057 8.5678 2.11449 9.35752 2.96062C10.1474 3.80697 10.5923 4.95626 10.5923 6.15596C10.5923 7.05049 10.3447 7.92443 9.88149 8.66721C9.4183 9.40994 8.76066 9.98773 7.99254 10.3286C7.22453 10.6695 6.37988 10.7585 5.56508 10.5849C4.75021 10.4112 4.00069 9.98233 3.41173 9.3513C2.8227 8.7202 2.42087 7.91532 2.25802 7.03812C2.09516 6.16091 2.1788 5.25172 2.4981 4.42578C2.81739 3.59988 3.35768 2.89507 4.04961 2.39971Z" fill="white" stroke="#512DA8" strokeWidth="0.2" />
                                <path d="M14.4588 15.4864C14.5436 15.4869 14.6274 15.4694 14.7054 15.4352C14.7836 15.401 14.8543 15.3507 14.9136 15.2877C14.973 15.2245 15.0198 15.1497 15.0517 15.0677C15.0835 14.9858 15.0999 14.8981 15.0999 14.8097C15.0999 14.7213 15.0835 14.6337 15.0517 14.5517C15.0199 14.4698 14.9731 14.3951 14.9137 14.3319C14.9137 14.3319 14.9136 14.3318 14.9136 14.3318L10.6104 9.71858C10.5513 9.65523 10.4808 9.60457 10.4026 9.56987C10.3245 9.53516 10.2404 9.51719 10.1554 9.51719C10.0703 9.51719 9.98625 9.53516 9.90808 9.56987C9.82994 9.60457 9.7594 9.65523 9.70031 9.71858C9.64123 9.78191 9.5947 9.85673 9.56307 9.9386C9.53144 10.0205 9.51523 10.108 9.51523 10.1962C9.51523 10.2845 9.53144 10.372 9.56307 10.4539C9.5947 10.5357 9.64123 10.6106 9.70031 10.6739L14.0037 15.2874L14.004 15.2877C14.0633 15.3507 14.134 15.401 14.2122 15.4352C14.2902 15.4694 14.3741 15.4869 14.4588 15.4864ZM14.4588 15.4864C14.4586 15.4864 14.4584 15.4864 14.4582 15.4864L14.4588 15.3864L14.4594 15.4864C14.4592 15.4864 14.459 15.4864 14.4588 15.4864Z" fill="white" stroke="#512DA8" strokeWidth="0.2" />
                            </svg>
                            <span style={{ color: 'white' }}>

                                Search
                            </span>
                        </button>
                    </form>
                    {products?.length > 0 &&
                        <ProductTable
                            products={products}
                            handleAddtoSchedule={handleAddtoSchedule}
                        />
                    }
                    {/* Selected Products List */}
                    {selectedproducts.length > 0 && (
                        <div className={styles.selectedProductsContainer}>
                            <h3>Selected Products</h3>
                            <table className={styles.selectedProductsTable}>
                                <thead>
                                    <tr>
                                        <th>Product Name</th>
                                        <th>SPQ</th>
                                        <th>Total Quantity</th>
                                        <th>Schedule Quantity</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedproducts.map((item, index) => {
                                        const minMultiplier = item?.productDetails?.inventory?.minimumMultiplier || 1;
                                        return (
                                            <tr key={index} className={styles.selectedProductRow}>
                                                <td className={styles.productNameCell}>
                                                    {item.productDetails?.productOverview?.productNumber}
                                                </td>
                                                <td>{minMultiplier}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={item.totalQty}
                                                        onChange={(e) => handleTotalQuantityChange(item.productId, e.target.value, item.quantity)}
                                                        onBlur={() => handleQuantityBlur(item.productId, true)}
                                                        onFocus={() => handleQuantityFocus(item.productId, true)}
                                                        min="1"
                                                        step={minMultiplier}
                                                        className={styles.quantityInput}
                                                    />
                                                    {totalQuantityErrors[item.productId] && (
                                                        <div className={styles.errorText}>
                                                            {totalQuantityErrors[item.productId]}
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={item.quantity}
                                                        onChange={(e) => handleQuantityChange(item.productId, e.target.value, item.totalQty)}
                                                        onBlur={() => handleQuantityBlur(item.productId)}
                                                        onFocus={() => handleQuantityFocus(item.productId)}
                                                        min="1"
                                                        max={item.totalQty}
                                                        step={minMultiplier}
                                                        className={styles.quantityInput}
                                                    />
                                                    {quantityErrors[item.productId] && (
                                                        <div className={styles.errorText}>
                                                            {quantityErrors[item.productId]}
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => handleRemoveProduct(item.productId)}
                                                        className={styles.removeButton}
                                                    >
                                                        Remove
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <p className={styles.addCatLabel} style={{ marginTop: 10 }}>Choose the file and sheet to upload. At minimum you will need to include part numbers and quantities for each.</p>

                    <div className={styles.imageUpload}>
                        <h2 className={styles.addCatH2}>Upload PO</h2>
                        <label htmlFor="fileUpload">
                            {loading ?
                                <div className={styles.uploadBox}>
                                    please wait...
                                </div>
                                :
                                <>
                                    {formik.values.purchaseOrderUri ?
                                        <div className={styles.uploadBox}>
                                            {formik.values.purchaseOrderUri}
                                        </div>
                                        :
                                        <div className={styles.uploadBox} style={{ cursor: 'pointer' }}>
                                            <span className={styles.uploadIcon}>
                                                <Upload />
                                            </span>
                                            <p className={styles.addCatPara}>Choose the file and sheet to upload</p>
                                            <input
                                                type="file"
                                                style={{ display: 'none' }}
                                                id="fileUpload"
                                                accept=".xlsx, .xls"
                                                onChange={handleFileUpload}
                                            />
                                            <button type="button" className={styles.addImgBtn}>
                                                Choose File
                                            </button>
                                        </div>
                                    }
                                </>
                            }
                        </label>
                        {formik.errors.purchaseOrderUri && formik.touched.purchaseOrderUri && (
                            <div className={styles.errorText}>{formik.errors.purchaseOrderUri}</div>
                        )}
                        <p className={styles.addCatLabel}>We support .xls, .xlsx, and .csv files under 4MB</p>
                    </div>

                    <h2 className={styles.addCatH2} style={{ marginTop: "30px" }}>Fill the below details</h2>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                            Customer
                            <select
                                className={styles.addCatSelect}
                                name="userId"
                                value={formik.values.userId}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            >
                                <option value="">Select</option>
                                {allUsers?.map((i) => (
                                    <option value={i?._id}>{i?.fullName}</option>
                                ))
                                }

                            </select>
                            {formik.errors.userId && formik.touched.userId && (
                                <div className={styles.errorText}>{formik.errors.userId}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                            Months Period
                            <input
                                type="number"
                                name="period"
                                placeholder="Enter period"
                                className={styles.addCatInput}
                                value={formik.values.period}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.period && formik.touched.period && (
                                <div className={styles.errorText}>{formik.errors.period}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                            Schedule Date
                            <input
                                type="date"
                                name="scheduleDate"
                                placeholder="Enter schedule date"
                                className={styles.addCatInput}
                                value={formik.values.scheduleDate}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.scheduleDate && formik.touched.scheduleDate && (
                                <div className={styles.errorText}>{formik.errors.scheduleDate}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                            Project remarks
                            <input
                                type="text"
                                name="remarks"
                                placeholder="Enter remarks"
                                className={styles.addCatInput}
                                value={formik.values.remarks}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.errors.remarks && formik.touched.remarks && (
                                <div className={styles.errorText}>{formik.errors.remarks}</div>
                            )}
                        </label>
                    </div>
                    <div className={styless.displayFlex} style={{ marginTop: "30px" }}>
                        <button className={styless.cancelBtn}>Cancel</button>
                        <button
                            className={styless.submitBtn}
                            onClick={handleSubmit}
                            disabled={selectedproducts.some(item => !isQuantityValid(item.productId))}
                        >
                            Approve & submit
                        </button>
                    </div>
                </div>
            </div>
            <DeliveryAddressPopup
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                setOpen={setOpen}
                open={open}
                handleSubmit={handleSaveSelection}
               customer={shippingAddress}
            />
        </>
    )
}

export default NewSchedule